import React, { useEffect, useState, createRef, FunctionComponent } from "react";
import styles from "./Accordion.module.scss";
import AccordionProps from "./AccordionProps.interface";
import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import handleOpenModal from "blocks/helpers/handleOpenModal";
import { useDispatch } from "react-redux";
import Button from "components/Button/Button";

const Accordion: FunctionComponent<AccordionProps> = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [height, setHeight] = useState("0px");
    const content = createRef<HTMLDivElement>();
    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const iconIsOpen = isOpen ? ` ${styles.iconIsOpen}` : undefined;
    const contentIsOpen = isOpen ? ` ${styles.contentIsOpen}` : undefined;
    const processedHeadline = getProcessedRichtext(props.content.heading);

    const dispatch = useDispatch();

    useEffect(() => {
        if (content.current) {
            setHeight(!isOpen ? "0px" : `${content.current.scrollHeight}px`);
        }
    }, [isOpen, content]);

    return (
        <div className={styles.wrapper}>
            {/* Title */}
            <button tabIndex={0} className={styles.header} onClick={() => setIsOpen(!isOpen)}>
                <span className={combineClasses([styles.icon, iconIsOpen])} />
                {processedHeadline ? (
                    <span className={styles.title} dangerouslySetInnerHTML={processedHeadline}></span>
                ) : null}
            </button>

            {/* Content */}
            <div className={combineClasses([styles.content, contentIsOpen])} ref={content} style={{ maxHeight: `${height}` }}>
                {processedBodyText ? (
                    <div dangerouslySetInnerHTML={processedBodyText}></div>
                ) : null}

                {/* Buttons */}
                {props.content.buttons && props.content.buttons.length > 0 ? (
                    <div className={styles.buttons}>
                        {props.content.buttons.map((button, index) => {
                            return (
                                <Button key={button.contentUdi} className={styles.button} modal={button.content.modal} onClick={() => { button.content.modal ? handleOpenModal(button.content.modal, button.content.stickyLink, dispatch) : undefined; }} to={button.content.link} parameters={button.content.parameters} anchor={button.content.anchor} settings={button.settings}>
                                    {button.content.label}
                                </Button>
                            );
                        })}
                    </div>
                ) : null}

                <span className={styles.item__spacer} />
            </div>
        </div>
    );
};

export default Accordion;